import { Box, SvgIcon } from "@mui/material";
import type React from "react";
import { AlertCircle, Check } from "react-feather";

import { InfoIcon } from "src/components/generics/icons/infoIcon/InfoIcon";
import type { NotificationPriority } from "src/types/notification";

import { useNotificationIconStyles } from "./Notifications.styles";

interface NotificationIconProps {
    priority: NotificationPriority;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({ priority }) => {
    const classes = useNotificationIconStyles();

    return (
        <Box display="flex" px={2} alignItems="center">
            {
                {
                    validation: (
                        <SvgIcon fontSize="small" className={classes.success}>
                            <Check />
                        </SvgIcon>
                    ),
                    info: <InfoIcon />,
                    warning: (
                        <SvgIcon fontSize="small" className={classes.warning}>
                            <AlertCircle />
                        </SvgIcon>
                    ),
                    error: (
                        <SvgIcon fontSize="small" color="error">
                            <AlertCircle />
                        </SvgIcon>
                    ),
                }[priority]
            }
        </Box>
    );
};
